// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { Button, Glyphicon } from 'react-bootstrap';
import '../../styles/components/LoaderButton.css';

export default ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  isLoading,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  text,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  loadingText,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  className = '',
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  disabled = false,
  ...props
}) => (
  <Button
    className={`LoaderButton ${className}`}
    bsStyle='primary'
    disabled={disabled || isLoading}
    {...props}
  >
    {isLoading && <Glyphicon glyph='refresh' className='spinning' />}
    {!isLoading ? text : loadingText}
  </Button>
);
